/** Contentful constant keys used by the checkout step cards. */
export const CHECKOUT_CONSTANT_KEYS = {
  DELIVERY_ADDRESS: 'i18n_cart_checkout_shipping-address',
  BILLING_ADDRESS: 'i18n_cart_checkout_details_order-address',
  PAYMENT: 'i18n_cart_checkout_details_payment',
  CHANGE: 'i18n_cart_checkout_details_change',
  PACKAGE_STATION: 'i18n_cart_checkout_details_package-station',
  LIKE_SHIPPING_ADDRESS: 'i18n_cart_checkout_like-shipping-address',
  PAYMENT_NOT_REQUIRED: 'i18n_payment_not_required',
  DPO_LABEL: 'i18n_cart_dpo_checkbox',
  DPO_TURNED_ON: 'i18n_cart_dpo_turnedon',
  DPO_TURNED_OFF: 'i18n_cart_dpo_turnedoff',
  /** Error shown on the DK data-privacy checkbox when the customer orders without ticking it. */
  DATA_PRIVACY_ERROR: 'i18n_data_privacy_and_policy_combined',
  SHOW_MORE: 'i18n_show_more',
  SHOW_LESS: 'i18n_show_less',
  /** Accessible name of the buy button; must start with the visible label ("Jetzt kaufen"). */
  ORDER_BUTTON_ARIA_LABEL: 'i18n_cart_checkout_order_button_aria_label',
  FOOTER_ARIA_LABEL: 'i18n_cart_checkout_footer_aria_label'
} as const;

/** Order success page, still served by Gatsby: needs a hard navigation, the order id is appended. */
export const ORDER_SUCCESS_ROUTE = '/cart/order/success/';

/** Contentful `id` of the sections (in an untyped article of the cart page) shown as hints above the checkout cards. */
export const CHECKOUT_HINT_SECTION_ID = {
  PAYPAL_EXPRESS_NEW_CUSTOMER: 'section_cart_paypal_express_new_customer',
  PAYPAL_EXPRESS_MERGE: 'section_cart_paypal_express_merge',
  GENERAL_MERGE: 'section_cart_general_merge'
} as const;

/** Contentful `id` of the sections (in an untyped article of the cart page) that make up the legal notice. */
export const CHECKOUT_LEGAL_SECTION_ID = {
  /** Sentence with `{{ openDialog(id:<section id>): <label> }}` markers. */
  TEXT: 'section_cart_checkout_dataprivacy',
  TERMS: 'section_cart_checkout_dataprivacy_agb',
  PRIVACY: 'section_cart_checkout_dataprivacy_datenschutzerklaerung'
} as const;

/** Maps the PSI payment type of the current payment to its Contentful label key (Gatsby: mapPaymentTypesToLabel). */
export const CHECKOUT_PAYMENT_LABEL_KEYS = {
  gui_visa: 'i18n_payment_visa',
  gui_master: 'i18n_payment_mastercard',
  gui_amex: 'i18n_payment_american_express',
  paypal: 'i18n_payment_paypal',
  gui_pp_express: 'i18n_payment_paypal_express',
  invoice: 'i18n_payment_invoice',
  ideal: 'i18n_payment_iDeal',
  gui_maestro: 'i18n_payment_maestro',
  sepa: 'i18n_payment_sepa',
  gui_dankort: 'i18n_payment_dankort',
  mobile_pay: 'i18n_payment_mobile_pay',
  twint: 'i18n_payment_twint'
} as const;
